import axiosInstance from '../components/apiService';

const getMyBudget = () => {
  return axiosInstance.get('influencer-budgets/my-budget');
};

const getCurrentBudget = (customerId) => {
  return axiosInstance.get(`influencer-budgets/current/${customerId}`);
};

const getBudgetHistory = (customerId) => {
  return axiosInstance.get(`influencer-budgets/history/${customerId}`);
};

const getMyBudgetHistory = () => {
  return axiosInstance.get('influencer-budgets/my-history');
};

const allocateBudget = (customerId, amount, month, year) => {
  // Format yearMonth as "YYYY-MM" string (e.g., "2025-12")
  const yearMonth = `${year}-${String(month).padStart(2, '0')}`;

  return axiosInstance.post('influencer-budgets/allocate', {
    customerId: Number(customerId),
    yearMonth: yearMonth,
    allocatedAmount: Number(amount),
  });
};

const getAllCurrentBudgets = () => {
  return axiosInstance.get('influencer-budgets/all-current');
};

const getAdminBudgetOverview = (yearMonth) => {
  const params = yearMonth ? `?yearMonth=${yearMonth}` : '';
  return axiosInstance.get(`influencer-budgets/admin/overview${params}`);
};

const getAdminBudgetOverviewFiltered = (filter) => {
  return axiosInstance.post('influencer-budgets/admin/overview/filter', filter);
};

const getAvailableYearMonths = () => {
  return axiosInstance.get('influencer-budgets/admin/available-months');
};

const InfluencerBudgetService = {
  getMyBudget,
  getCurrentBudget,
  getBudgetHistory,
  getMyBudgetHistory,
  allocateBudget,
  getAllCurrentBudgets,
  getAdminBudgetOverview,
  getAdminBudgetOverviewFiltered,
  getAvailableYearMonths,
};

export default InfluencerBudgetService;
